<template>
  <div class="text-center pa-4" style="width: 100%">
    <v-btn
      @click="gotoPage(page.url, page.label)"
      small
      :disabled="page.active || !page.url"
      text
      :color="$vuetify.theme.isDark ? 'white' : 'orange'"
      v-for="(page, i) in links"
      :key="i"
      v-html="page.label"
    ></v-btn>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["goto", "gotoFilterPage"],
  props: {
    links: Array,
  },
  name: "PaginationComponent",
  data() {
    return {
      current_page: 1,
    };
  },
  computed: {
    filterApplied() {
      return this.$store.state.filter_applied;
    },
  },
  methods: {
    gotoPage(url, label) {
      const controls = ["&laquo; Previous", "Next &raquo;"];
      let page = 1;

      if (controls.includes(label)) {
        page = this.current_page;

        if (label === "&laquo; Previous") {
          page = page - 1;
        } else {
          page = Number(page) + 1;
        }
      } else {
        page = label;
      }

      this.current_page = page;

      this.$router.replace({ path: this.$route.path + "?page=" + page });

      if (this.filterApplied) {
        this.$emit("gotoFilterPage", page);
      } else {
        this.$emit("goto", page);
      }
    },
  },
});
</script>

<style scoped></style>
